<template>
<svg xmlns="http://www.w3.org/2000/svg" :fill="useCurrentColor ? 'currentColor' : '#000'" viewBox="0 0 48 48" :class="[`${prefix}-icon`, `${prefix}-icon-Copy`]" width="1em" height="1em" v-bind="$attrs"><defs><clipPath id="svg_79d3abe929__a"><rect width="48" height="48" rx="0"/></clipPath></defs><g clip-path="url(#svg_79d3abe929__a)"><path d="M21.068199999999997,8.63636C20.2021,8.63636,19.5,7.93426,19.5,7.06818C19.5,6.2020990000000005,20.2021,5.5,21.068199999999997,5.5L34.2,5.5Q36.8095,5.5,38.6548,7.3372399999999995Q40.5,9.174479999999999,40.5,11.77273L40.5,26.925C40.5,27.7948,39.7948,28.5,38.925,28.5C38.055099999999996,28.5,37.35,27.7948,37.35,26.925L37.35,11.77273C37.35,10.04056,35.9397,8.63636,34.2,8.63636L21.068199999999997,8.63636ZM12.202210000000001,42.5L28.79,42.5C31.384,42.5,33.4922,40.1883,33.5,37.3438L33.5,17.6562C33.5,14.81171,31.3919,12.5,28.7978,12.5L12.202210000000001,12.5C9.60817,12.5,7.5,14.81171,7.5,17.6562L7.5,37.3438C7.5,40.1883,9.60817,42.5,12.202210000000001,42.5ZM10.6348,17.6562C10.6348,16.710900000000002,11.34014,15.9375,12.202210000000001,15.9375L28.7978,15.9375C29.6599,15.9375,30.3652,16.710900000000002,30.3652,17.6562L30.3652,37.3438C30.3652,38.2891,29.6599,39.0625,28.7978,39.0625L12.202210000000001,39.0625C11.34014,39.0625,10.6348,38.2891,10.6348,37.3438L10.6348,17.6562Z" fill-rule="evenodd"/></g></svg>
</template>
<script>

export default {
  name: 'IconCopy',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
